import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../Modal'
import Button from '../Button'
import checkIcon from 'images/check.svg'

const ConfirmationModal = ({
  t,
  title,
  message,
  onConfirm: confirmCallback,
}) => (
  <Modal
    center
    isOpen
    size='sm'
    showHeader={false}
    showFooter={false}
    renderButton={() => null}
    renderChildrenWithProps={({ onConfirm }) => (
      <div className='confirm-modal'>
        <img src={checkIcon} />
        <p className='title'>{title}</p>
        {typeof message === 'function' ? message() : <p>{message}</p>}
        <div className='button-row'>
          <Button
            className='btn-sm btn-primary'
            text={t('close_button_label')}
            onClick={() => {
              onConfirm && onConfirm()
              confirmCallback && confirmCallback()
            }}
          />
        </div>
      </div>
    )}
  />
)

ConfirmationModal.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.any.isRequired,
  onConfirm: PropTypes.func.isRequired,
  renderButton: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default ConfirmationModal
